import { render, staticRenderFns } from "./LogisticModal.vue?vue&type=template&id=787962e4&scoped=true&"
import script from "./LogisticModal.vue?vue&type=script&lang=js&"
export * from "./LogisticModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787962e4",
  null
  
)

export default component.exports